import { TRESPONSE_LINEWISE_PLANNED_QTY_CARD_DATA } from '@monorepo/types';
import { ModifiersZTableModel } from '../../table.modifier';

export const LINEWISE_PLANNED_QTY_CARD_TABLE_MODEL = {
  createModel: (data: TRESPONSE_LINEWISE_PLANNED_QTY_CARD_DATA) => {
    return ModifiersZTableModel.createTableModel(
      data.data,
      {
        padding: 8,
        headerConfig: data.headerInfo.map((h) => ({
          type: 'TEXT_CELL' as const,
          text: h.displayName,
          align: 'center' as const,
          widthInPx: 100,
        })),
      },
      (item) => {
        return {
          type: 'ROW',
          rowItem: item,
          cells: data.headerInfo.map((h) => ({
            type: 'TEXT_CELL' as const,
            text: item[h.key] ?? '- -',
            align: 'center' as const,
          })),
        };
      },
    );
  },
};
